<template lang="pug">
  .notification
    .notification__header
      .notification__title Поступил платеж
      .notification__date {{ hours }}
    .notification__body
      p.notification__content
        template(v-if="isAdmin")
          | Платеж на сумму
          strong {{ payload.amount | currency }}
          | от пользователя:
          strong {{ payload.firmName }}
          br
          a(v-bind:href="'mailto:' + payload.firmEmail") {{ payload.firmEmail }}
        template(v-else)
          | Поступил платеж на сумму {{ payload.amount | currency }} на ваш баланс в СonPlus.
          br
          router-link.notification__link(
            @click.native="emitClick"
            title="Платежи и баланс"
            :to="{name: 'payments'}"
          ) Платежи и баланс
</template>

<script>
import notification from '@/mixins/notification.mixin';

export default {
  name: 'BalanceReplenish',
  mixins: [notification]
};
</script>
